export default __webpack_public_path__ + "public/assets/images/d491181582f70c7b6a2761c795aeb739.png";